<meta-title i18n>יצירת קשר</meta-title>

<div class="auth-page">
  <header class="auth-page-header">
    <h2 i18n>יצירת קשר</h2>
  </header>

  <div class="auth-card auth-card--stack auth-card--plain">
    <p class="auth-section-label" i18n>ליצירת קשר או לקבלת עזרה טכנית במערכת ניתן לפנות למשרד מידע ורישום</p>

    <section class="auth-contact-block" *ngIf="sections[l10n.code]">
      <h3 i18n>{{ sections[l10n.code].title }}</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">{{ sections[l10n.code].phone }}</ui-phone-link>
        <ui-mail-link color="primary">{{ sections[l10n.code].mail }}</ui-mail-link>
      </div>
    </section>

    <section class="auth-contact-block">
      <h3 i18n>קמפוס לב</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">*3239</ui-phone-link>
        <ui-mail-link color="primary">harshama@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <section class="auth-contact-block">
      <h3 i18n>קמפוס טל</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">*3239</ui-phone-link>
        <ui-mail-link color="primary">harshama-tal@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <section class="auth-contact-block">
      <h3 i18n>קמפוס לוסטיג</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">*3118</ui-phone-link>
        <ui-mail-link color="primary">harshama-lustig@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <section class="auth-contact-block">
      <h3 i18n>מח"ר תבונה</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">*3463</ui-phone-link>
        <ui-mail-link color="primary">tvuna@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <div class="auth-section-divider"></div>

    <p class="auth-section-label" i18n>ליצירת קשר בעניין תשלומי מקדמות ושוברים</p>

    <section class="auth-contact-block">
      <h3 i18n>קמפוס לב</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">02-6751255</ui-phone-link>
        <ui-mail-link color="primary">heshbonot@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <section class="auth-contact-block">
      <h3 i18n>קמפוס טל</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">02-6547207</ui-phone-link>
        <ui-mail-link color="primary">heshbonot@jct.ac.il</ui-mail-link>
      </div>
    </section>

    <div class="auth-section-divider"></div>

    <p class="auth-section-label" i18n>ליצירת קשר בעניין שם משתמש וסיסמה</p>

    <section class="auth-contact-block">
      <h3 i18n>תמיכה</h3>
      <div class="auth-contact-block__links">
        <ui-phone-link color="primary">02-6751152</ui-phone-link>
        <a
          class="auth-contact-block__action"
          mat-stroked-button
          color="primary"
          href="https://forms-jct.binaa.co.il/it-support-ticket/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <mat-icon>support_agent</mat-icon>&nbsp;
          <span i18n>פתיחת קריאת תמיכה</span>
        </a>
      </div>
    </section>
  </div>
</div>
